import Connection from 'utils/connection';
import * as api from 'constants/api';

const getAgentWallet = async ({ state }) => {
  const { result } = await Connection.get(api.GET_AGENT_WALLET);

  return (state.wallets = result);
};

const getAgentAvailableCurrencies = async ({ state }, fromState = false) => {
  if (state.agentAvailableCurrencies && fromState) return state.agentAvailableCurrencies;

  const { result } = await Connection.get(api.GET_AGENT_AVAILABLE_CURRENCIES);

  return (state.agentAvailableCurrencies = result);
};

const getAgentAllWallets = async ({ state, effects }) => {
  state.agents = {
    ...state.agents,
    agent: {
      ...state.agents.agent,
      wallets: { ...state.agents.agent.wallets, isBusy: true, records: [] },
    },
  };
  const { result } = await effects.agents.getAgentAllWallets();

  const resultMap = result?.reduce((walletMap, wallet) => ({ ...walletMap, [wallet.currencyCode]: wallet }), {});

  state.agents = {
    ...state.agents,
    agent: {
      ...state.agents.agent,
      wallets: {
        ...state.agents.agent.wallets,
        isBusy: false,
        records: resultMap,
      },
    },
  };
};

const setNeededReloadState = ({ state }, { key, value }) => {
  return (state.neededReload[key] = value);
};

export default {
  getAgentWallet,
  getAgentAllWallets,
  setNeededReloadState,
  getAgentAvailableCurrencies,
};
